// extracted by mini-css-extract-plugin
export default {"movie-grid":"MovieGrid_movie-grid__XGjkb","load-more":"MovieGrid_load-more__0EE6h"};